export const GET_STATISTICS_USED_CHIPS = "GET_STATISTICS_USED_CHIPS";
export const CLEAR_FILTERS_USED_CHIPS = "CLEAR_FILTERS_USED_CHIPS";